import React from 'react'
import profileLinkMap from '../../utils/constants/profile_link_map'

const defaultColumn = {
  row_key: '',
  custom_link_text: ''
}

const buildProfileLink = (id) => `${window.MAIN}/profile/${id}`
const buildProfileLinkWithSourceAndType = (row, profileLink) => {
  if (row.type === 'medicaid_exclusion')
    return {link: `${profileLink}/${profileLinkMap[row.type.toLowerCase()]}`, extended_link: true};

  if (row.source && profileLinkMap[row.source.toLowerCase()])
    return {link: `${profileLink}/${profileLinkMap[row.source.toLowerCase()]}`, extended_link: true};

  return {link: profileLink, extended_link: false};
}

const encodeLink = (link) => btoa(link)
export const buildGroupReportLink = (row = {}, column = defaultColumn, trackClick = () => {}) =>
  <a
    target="_blank"
    href={`${window.MAIN}/client/configuration/switch_current_account?action=index&client_id=${row[column.client_id]}&controller=client_accounts&link_path=`+`${encodeLink(window.MAIN+'/workflow/'+row[column.row_key])}`}
    onClick={() => trackClick()}>
    {column.custom_text}
  </a>

export const buildChecklistLink = (row = {}, column = defaultColumn, trackClick = () => {}) =>
  <a
    target="_blank"
    href={`${window.MAIN}/workflow/${row[column.row_key]}`}
    onClick={() => trackClick()}>
    {column.custom_text}
  </a>

export const buildMonitoringLink = (row = {}, column = defaultColumn, trackClick = () => {}) => {
  const profileLink = buildProfileLink(row[column.row_key])
  const {link, extended_link} = buildProfileLinkWithSourceAndType(row, profileLink)

  return extended_link ?
    <a target="_blank" href={link} onClick={() => trackClick()}> {column.custom_text}</a> :
    <a target="_blank" title="No monitoring alerts." href={link} onClick={() => trackClick()}><i className="fa fa-check"></i></a>
}

export const buildExpirationsLink = (row = {}, column = defaultColumn, trackClick = () => {}) => {
  const profileLink = buildProfileLink(row[column.row_key])
  return (row.expirable && profileLinkMap[row.expirable.toLowerCase()])
  ? <a
    target="_blank"
    href={`${profileLink}/${profileLinkMap[row.expirable.toLowerCase()]}`}
    onClick={() => trackClick()}>
    {column.custom_text}
  </a>
  : <a target="_blank" href={profileLink} onClick={() => trackClick()}>{column.custom_text}</a>
}
